import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Tag } from 'Components/Pages/Results/Tags';

class RecommendationTagList extends Component {
  render() {
    return (
      <ol className="HideTagList">
        {this.props.tags.map((tag, i) => {
          return (
            <li className={`TagListItem`} key={i}>
              <Tag tag={tag} />
            </li>
          );
        })}
      </ol>
    );
  }
}

RecommendationTagList.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default RecommendationTagList;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/RecommendationTagList.js